<div class="container">
  <div class="admin-page-header">
    <h2 class="title admin-page-title">{{'pendingevent.title'|traduccion}}</h2>
    <div class="header-actions">
      <span class="summary-chip">{{'pendingevent.totalElements'|traduccion}}: {{ totalItems() }}</span>
      <button mat-stroked-button class="refresh-table-button" (click)="loadPendingEvents()">
        <mat-icon>refresh</mat-icon>
        {{'table.retry'|traduccion}}
      </button>
    </div>
  </div>

  <mat-card class="table-card">
    <app-data-table
      [dataSource]="dataSource"
      [displayedColumns]="displayedColumns"
      [loading]="loading"
      [emptyMessage]="'pendingevent.table.nodata'|traduccion"
      [showPaginator]="true"
      [length]="totalItems()"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions"
      [rowClickable]="true"
      (page)="onPageChange($event)"
      (rowClick)="openDetails($event.row)">
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>{{'pendingevent.table.header.status'|traduccion}}</th>
        <td mat-cell *matCellDef="let pendingEvent">
          <span [class]="statusClass(pendingEvent.status)">{{ formatEnumLabel(pendingEvent.status) }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="eventName">
        <th mat-header-cell *matHeaderCellDef>{{'pendingevent.table.header.eventName'|traduccion}}</th>
        <td mat-cell *matCellDef="let pendingEvent">
          <div class="entity-cell">
            <strong>{{ valueOrDash(pendingEvent.eventName) }}</strong>
            <span class="muted-inline">{{ valueOrDash(pendingEvent.entityType) }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="aggregate">
        <th mat-header-cell *matHeaderCellDef>{{'pendingevent.table.header.aggregate'|traduccion}}</th>
        <td mat-cell *matCellDef="let pendingEvent">
          <div class="entity-cell">
            <strong>{{ valueOrDash(pendingEvent.eventAggregateType) }}</strong>
            <code>{{ valueOrDash(pendingEvent.eventAggregateId) }}</code>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="payload">
        <th mat-header-cell *matHeaderCellDef>{{'pendingevent.table.header.payload'|traduccion}}</th>
        <td mat-cell *matCellDef="let pendingEvent">
          <code class="payload-code">{{ payloadPreview(pendingEvent.payload) }}</code>
        </td>
      </ng-container>

      <ng-container matColumnDef="retryCount">
        <th mat-header-cell *matHeaderCellDef>{{'pendingevent.table.header.retryCount'|traduccion}}</th>
        <td mat-cell *matCellDef="let pendingEvent">{{ valueOrDash(pendingEvent.retryCount) }}</td>
      </ng-container>

      <ng-container matColumnDef="lastSentAt">
        <th mat-header-cell *matHeaderCellDef>{{'pendingevent.table.header.lastSentAt'|traduccion}}</th>
        <td mat-cell *matCellDef="let pendingEvent">{{ formatDateTime(pendingEvent.lastSentAt) }}</td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>{{'pendingevent.table.header.createdAt'|traduccion}}</th>
        <td mat-cell *matCellDef="let pendingEvent">{{ formatDateTime(pendingEvent.createdAt) }}</td>
      </ng-container>
    </app-data-table>
  </mat-card>
</div>
